<template>
  <v-row class="mt-2" :class="!$vuetify.breakpoint.smAndDown ? 'mr-16' : ''">
    <v-col
      cols="6"
      sm="6"
      xs="6"
      xl="4"
      lg="4"
      md="4"
      align="center"
      v-for="item in this.filterdMembers"
      :key="item.name"
    >
      <Member :name="item.name" :job="item.job" :imgName="item.imgPath" />
    </v-col>
  </v-row>
</template>

<script>
import Member from "@/components/team/Member.vue";

export default {
  components: { Member },

  // watch: {
  //   "$store.state.Teamfilters"(val) {

  //     if (
  //       val == null ||
  //       val.length < 1 ||
  //       (val.length == 1 && val[0] == "all teams")
  //     ) {
  //       this.members = this.membersMatchSearchQuery;
  //       return;
  //     }
  //     this.members = this.membersMatchSearchQuery.filter((member) => {
  //       return val.some((el) => member.categories.includes(el));
  //     });
  //   },
  //   "$store.state.Specfilters"(val) {

  //     if (
  //       val == null ||
  //       val.length < 1 ||
  //       (val.length == 1 && val[0] == "all specialists")
  //     ) {
  //       this.members = this.membersMatchSearchQuery;
  //       return;
  //     }
  //     this.members = this.membersMatchSearchQuery.filter((member) => {
  //       return val.some((el) => member.specialists.includes(el));
  //     });
  //   },
  // },

  computed: {
    filterdMembers() {
      // console.log(this.$store.state.Teamfilters);
      // console.log(this.$store.state.Specfilters);

      var filterd = [];
      if (
        this.$store.state.Teamfilters == null ||
        this.$store.state.Teamfilters=="" ||
        this.$store.state.Teamfilters == "all teams"
      ) {
        filterd = this.membersMatchSearchQuery;
      } else {
        filterd = this.membersMatchSearchQuery.filter((member) => {
          return member.categories.includes(this.$store.state.Teamfilters);
        });
      }
      //handle second filter
      if (
        this.$store.state.Specfilters == null ||
        this.$store.state.Specfilters=="" ||
       this.$store.state.Specfilters == "all specialists"
      )
        return filterd;

      filterd = filterd.filter((member) => {
        return  member.specialists.includes(this.$store.state.Specfilters)
       
      });

      return filterd;
    },

    membersMatchSearchQuery() {
      if (this.$store.state.SearchQuery) {
        return this.$store.state.TeamMembers.filter((member) => {
          return member.name
            .toLowerCase()
            .includes(this.$store.state.SearchQuery.toLowerCase());
        });
      }
      return this.$store.state.TeamMembers;
    },
  },
};
</script>